module.exports = __webpack_public_path__ + "static/brenda-0c06773401be2b290af83451df39ff9e.webp";